// extracted by mini-css-extract-plugin
export var boldText = "_64-4";
export var checkboxContainer = "_64-6";
export var closeIcon = "_64-i";
export var container = "_64-0";
export var drawer = "_64-8";
export var drawerContent = "_64-9";
export var extraSmallText = "_64-5";
export var fulfillmentGroupTable = "_64-e";
export var largeText = "_64-3";
export var loadingSpinnerContainer = "_64-j";
export var mediumText = "_64-2";
export var narrow = "_64-f";
export var notificationLink = "_64-l";
export var packageCheckIconContainer = "_64-7";
export var slideoutHeaderActions = "_64-g";
export var slideoutHeaderActionsShifted = "_64-h";
export var slideoutHeaderContainer = "_64-a";
export var slideoutModal = "_64-c";
export var stickyHeaderWrapper = "_64-b";
export var table = "_64-k";
export var tableContainer = "_64-d";
export var tertiaryText = "_64-1";